export enum AdformEntityType {
  DEALS = 'deals',
  ADVERTISERS = 'advertisers',
  CAMPAIGNS = 'campaigns',
  LINE_ITEMS = 'line_items',
  TAGS = 'tags',
  ADS = 'ads',
  PIXEL_IDS = 'pixel_ids',
  ALL = 'all',
}

export const ADFORM_ENTITY_OPTIONS = [
  { label: 'Deals', value: AdformEntityType.DEALS },
  { label: 'Advertisers', value: AdformEntityType.ADVERTISERS },
  { label: 'Campaigns', value: AdformEntityType.CAMPAIGNS },
  { label: 'Line Items', value: AdformEntityType.LINE_ITEMS },
  { label: 'Tags', value: AdformEntityType.TAGS },
  { label: 'Ads', value: AdformEntityType.ADS },
  { label: 'Pixel IDs', value: AdformEntityType.PIXEL_IDS },
  { label: 'All', value: AdformEntityType.ALL },
];
